<template>
    <div class="ring-on-ring-analysis">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点设计'" :style="`width:calc(${treeOuterWidth}px + 40px)`">
            <div class="tree-container" :style="`width:calc(${treeOuterWidth}px + 40px)`">
                <me-tree
                    ref="myTree"
                    :treeData="data"
                    :treeLoading="treeLoading"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :nodeKey="'point_id'"
                    :showCheckbox="true"
                    :title="'采集点设计'"
                    :cascadingVar="true"
                    :checkStrictly.sync="checkStrictly"
                    :isCheckClick="true"
                    :defaultCheckKeys="defaultCheckKeys"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    @handleCheckBoxClick="handleTreeNodeClick"
                    @handleStretchClick="handleStretchClick"
                ></me-tree>
            </div>
        </me-collapes>
        <div class="right_container is-alway-shadow leader-tab" :style="`width:calc(100% - ${treeOuterWidth}px - 40px)`">
            <el-tabs v-model="tabVal" type="card" @tab-click="handleClick">
                <el-tab-pane label="按日" name="day">
                </el-tab-pane>
                <el-tab-pane label="按周" name="week">
                </el-tab-pane>
                <el-tab-pane label="按月" name="month">
                 </el-tab-pane>
                <el-tab-pane label="按年" name="year">
                </el-tab-pane>
            </el-tabs>
            <div class="search_cont">
                <el-form
                    label-width="60px"
                    :inline="true"
                    :model="searchForm"
                    class="form leader-style-form"
                >
                    <el-form-item label="时间">
                        <el-date-picker
                            v-model="searchForm.time"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :picker-options="disableDate"
                            :clearable="false"
                            :editable="false"
                            v-if="this.tabVal == 'day' ? true : false"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="searchForm.time"
                            align="right"
                            type="date"
                            placeholder="选择周"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :picker-options="disableDate"
                            :clearable="false"
                            :editable="false"
                            v-if="this.tabVal == 'week' ? true : false"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="searchForm.time"
                            type="month"
                            placeholder="选择月"
                            value-format="yyyy-MM"
                            format="yyyy-MM"
                            :picker-options="disableDate"
                            :clearable="false"
                            :editable="false"
                            v-if="this.tabVal == 'month' ? true : false"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="searchForm.time"
                            align="right"
                            type="year"
                            placeholder="选择年"
                            value-format="yyyy"
                            format="yyyy"
                            :picker-options="disableDate"
                            :clearable="false"
                            :editable="false"
                            v-if="this.tabVal == 'year' ? true : false"
                        ></el-date-picker>
                    </el-form-item>
                    <div style="margin-right:10px;">
                        <el-button type="warning" size="medium" @click="search">查询</el-button>
                        <!-- <el-button
                            type="primary"
                            size="medium"
                            @click="getExcel"
                            >导出</el-button
                        >-->
                    </div>
                </el-form>
            </div>
            <div class="title">
                <div class="green"></div>
                按{{
                    tabVal === "day"
                        ? "日"
                        : tabVal === "week"
                            ? "周"
                            : tabVal === "month"
                                ? "月"
                                : "年"
                }}环比分析数据(kW·h)
            </div>
            <div class="table-wrap" style="margin-top: 5px;" v-loading="tableLoading">
                <el-table :data="tableData" border class="leader-style-table">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="point_name" label="采集点名称" width="180" align="center"></el-table-column>
                    <el-table-column
                        :label="
                            `当${this.tabVal === 'day'
                                ? '日'
                                : tabVal === 'week'
                                    ? '周'
                                    : tabVal === 'month'
                                        ? '月'
                                        : '年'
                            }用电`
                        "
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{
                                scope.row.total_power
                                    ? scope.row.total_power
                                    : "-"
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        :label="
                            `上${this.tabVal === 'day'
                                ? '日'
                                : tabVal === 'week'
                                    ? '周'
                                    : tabVal === 'month'
                                        ? '月'
                                        : '年'
                            }用电`
                        "
                    >
                        <template slot-scope="scope">
                            {{
                                scope.row.total_power_ago
                                    ? scope.row.total_power_ago
                                    : "-"
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="增长值" align="center">
                        <template slot-scope="scope">
                            {{
                                scope.row.total_power_diff
                                    ? scope.row.total_power_diff
                                    : "-"
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="环比（%）" align="center">
                        <template
                            slot-scope="scope"
                        >{{ scope.row.mom_rate ? scope.row.mom_rate : "-" }}</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import * as api from "../../../http/ring-on-ring-analysis";
import Collapes from "@/comon/components/collapse-block.vue";
import moment from "moment";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    data() {
        return {
            treeOuterWidth: 280,
            tabVal: "day",
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            loading: false,
            checkStrictly: true,
            defaultCheckKeys: [],
            defaultExpandedKeys: [],
            nodeKey: "point_id",
            tableData: [],
            tableLoading: false,
            searchForm: {
                time: ""
            },
            sysdate: "",
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysdate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            timeList: {},
            width: "calc(100% - 300px)"
        };
    },
    methods: {
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter() {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.w_active == "0") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else {
                    obj.disabled = false;
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        // 获取采集点
        getUnitPointList() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            this.treeLoading = true;
            api.getUnitPointList({ point_class_id: "001" }).then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );
                    this.defaultCheckKeys = this.defaultExpandedKeys = [formatData.firstPoint.point_id];
                    this.getDayData();
                }
                this.treeLoading = false;
            });
            loading.close();
        },

        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        },
        /**
         * 获取日报列表
         */
        getDayData() { 
            
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            params = {
                point_ids: point_ids,
                show_time: this.searchForm.time
            };
            this.tableLoading = true;
            api.getDayData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            }); 
        },
        /**
         * 获取日报列表
         */
        getWeekData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            params = {
                point_ids: point_ids,
                show_time: this.searchForm.time
            };
            this.tableLoading = true;
            api.getWeekData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取月报列表
         */
        getMonthData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_time: this.searchForm.time
            };
            api.getMonthData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取年报列表
         */
        getYearData() {
             this.loading = true;
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_time: this.searchForm.time
            };
            api.getYearData(params).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
        },
        // 获取系统时间
        getSysDate() {
            api.getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.timeList = res.bus_json;
                    this.sysdate = moment(new Date(this.timeList.sysdate))
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    this.searchForm.time = moment(
                        new Date(this.timeList.sysdate)
                    )
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                }
            });
        },
        // 切换tab
        handleClick() {
            switch (this.tabVal) {
                case "day":
                    this.sysdate = moment(new Date(this.timeList.sysdate))
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    this.searchForm.time = moment(
                        new Date(this.timeList.sysdate)
                    )
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    break;
                case "week":
                    this.sysdate = moment(new Date(this.timeList.sysdate))
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    this.searchForm.time = moment(
                        new Date(this.timeList.sysdate)
                    )
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    break;
                case "month":
                    this.sysdate = this.timeList.sysdate3;
                    this.searchForm.time = this.timeList.sysdate3;
                    break;
                case "year":
                    this.sysdate = this.timeList.sysdate4;
                    this.searchForm.time = this.timeList.sysdate4;
                    break;
            }
            this.search();
        },
        // 搜索
        search() {
            switch (this.tabVal) {
                case "day":
                    this.getDayData();
                    break;
                case "week":
                    this.getWeekData();
                    break;
                case "month":
                    this.getMonthData();
                    break;
                case "year":
                    this.getYearData();
                    break;
            }
        },
        //导出
        getExcel() {
            const loading = this.$loading({
                lock: true,
                text: "下载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(",") + ",";
            params = {
                point_ids: point_ids,
                show_time: this.searchForm.time,
                show_type:
                    this.tabVal == "day"
                        ? "1"
                        : this.tabVal == "week"
                            ? "2"
                            : this.tabVal == "month"
                                ? "3"
                                : "4"
            };
            api.getExcel(params).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.tabVal === "day"
                            ? this.searchForm.time + "日环比分析数据" + ".xlsx"
                            : this.tabVal === "week"
                                ? this.searchForm.time + "周环比分析数据" + ".xlsx"
                                : this.tabVal === "month"
                                    ? this.searchForm.time + "月环比分析数据" + ".xlsx"
                                    : this.searchForm.time + "年环比分析数据" + ".xlsx";
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent("MouseEvents");
                        evt.initEvent("click", false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: "下载成功！",
                        type: "success"
                    });
                }
                loading.close();
            });
        },
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 300px)" : "calc(100% - 56px)";
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
        }
    },
    mounted() {
        this.getSysDate();
    },
    created() {
        this.getUnitPointList();
    },
    watch: {
        width(val, newVal) {
            console.log(val, newVal);
        }
    }
};
</script>
<style lang="scss">
.ring-on-ring-analysis {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 0 1rem 0 0;
    .tree_container {
        width: px2Rem(280px);
        padding-bottom: 10px;
        height: calc(100% - 10px);
        // overflow-x: hidden;
    }
    .right_container {
        width: calc(100% - 300px);
        box-sizing: border-box;
        // margin: 4px 0px 10px 0;
        .el-tabs--card {
            margin: 0;
        }
        .search_cont {
            width: 100%;
            .form {
                display: flex;
                justify-content: space-between;
                .el-input__inner {
                    height: 36px;
                    line-height: 36px;
                }
            }
        }
        .green {
            height: 12px;
            width: 5px;
            background: #56fcff;
            margin: 10px;
            float: left;
        }
        .title {
            width: 100%;
            font-size: 16px;
            text-align: left;
            line-height: 32px;
            height: 32px;
            color: #fff;
            border-bottom: 1px solid #56fcff;
        }
    }
}
.el-card {
    order: 1px solid #ebeef5;
    background-color: #fff;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}
.is-alway-shadow {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
// .leader-style-table{overflow-y: scroll;}
// .el-table__body-wrapper{overflow: visible!important;}
.el-table__body-wrapper {height:90%;}
</style>
